import type { SecuritySettings } from '../types/settings';

export type PasswordFailure =
  | 'TOO_SHORT'
  | 'NO_UPPERCASE'
  | 'NO_LOWERCASE'
  | 'NO_NUMBER'
  | 'NO_SYMBOL'
  | 'CONTAINS_NAME_OR_EMAIL';

export interface PasswordValidationContext {
  name?: string;
  email?: string;
}

export interface PasswordValidationResult {
  valid: boolean;
  failures: PasswordFailure[];
}

const UPPERCASE = /[A-Z]/;
const LOWERCASE = /[a-z]/;
const NUMBER = /[0-9]/;
const SYMBOL = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~`]/;

export function validatePassword(
  password: string,
  policy: SecuritySettings,
  context?: PasswordValidationContext
): PasswordValidationResult {
  const failures: PasswordFailure[] = [];
  if (password.length < policy.passwordMinLength) failures.push('TOO_SHORT');
  if (policy.passwordRequireUppercase && !UPPERCASE.test(password)) failures.push('NO_UPPERCASE');
  if (policy.passwordRequireLowercase && !LOWERCASE.test(password)) failures.push('NO_LOWERCASE');
  if (policy.passwordRequireNumber && !NUMBER.test(password)) failures.push('NO_NUMBER');
  if (policy.passwordRequireSymbol && !SYMBOL.test(password)) failures.push('NO_SYMBOL');
  if (policy.passwordCannotContainName && context) {
    const lower = password.toLowerCase();
    const namePart = (context.name ?? '').toLowerCase().trim();
    const emailLocal = (context.email ?? '').toLowerCase().split('@')[0]?.trim() ?? '';
    const tokens = [namePart, emailLocal, ...namePart.split(/\s+/)].filter((t) => t.length >= 3);
    if (tokens.some((t) => lower.includes(t))) failures.push('CONTAINS_NAME_OR_EMAIL');
  }
  return { valid: failures.length === 0, failures };
}

export const FAILURE_LABELS: Record<PasswordFailure, string> = {
  TOO_SHORT: 'Tamanho mínimo',
  NO_UPPERCASE: 'Uma letra maiúscula',
  NO_LOWERCASE: 'Uma letra minúscula',
  NO_NUMBER: 'Um número',
  NO_SYMBOL: 'Um símbolo',
  CONTAINS_NAME_OR_EMAIL: 'Não contém seu nome ou email',
};
